$(document).ready(function () {
    if ($('#page').attr('data-page-id') === 'candidates') {
        let candidateTable = $('#candidates');
        let dateTableCandidate = candidateTable.DataTable({
            ajax: {
                url: 'get-candidates',
                data: function(d){
                    d.filters = {
                        'events.id': $('#eventFilter').val(),
                    }
                }
            },
            dataSrc: 'data',
            // processing: true,
            serverSide: true,
            responsive: true,
            lengthMenu: [[25, 50, -1], [25, 50, "All"]],
            columns: [
                { data: 'id', name: 'id', responsivePriority: 1 },
                { data: 'candidate_name', name: 'candidate_name', responsivePriority: 1 },
                { data: 'candidate_first_name', name: 'candidate_first_name' },
                { data: 'candidate_email', name: 'candidate_email' },
                { data: 'event_group_identifier', name: 'event_group_identifier' },
                { data: 'action', name: 'action', searchable: false, sortable: false, responsivePriority: 1 }
            ]
        });

        $('.filter').change(function (e) {
            // let orgFilter = $('#orgFilter').val().length === 0 ? '0' : $('#orgFilter').val();
            // let eventFilter = $('#eventFilter').val().length === 0 ? '0' : $('#eventFilter').val();
            dateTableCandidate.draw();
        });

        candidateTable.on('click', 'tbody tr', function (v) {
            let data = dateTableCandidate.row(this).data();
            if (data) {
                if ($(v.target).hasClass('delete') === true) {
                    let deleteCandidate = $('#delete-candidate');
                    deleteCandidate.find('.candidate-id').html(data.id)
                    deleteCandidate.find('.candidate-name').html(data.candidate_name);
                    deleteCandidate.find('#modal-delete').attr({'data-id': data.id});
                } else {
                    window.location.href = 'candidate/' + data.id;
                }
            }
        });

        $('#modal-delete').on('click', function () {
            let id = $(this).attr('data-id');
            $.ajaxSetup({
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            });

            $.ajax({
                type: "POST",
                data: {"_token": $('meta[name="csrftoken"]').attr('content'),"id": id},
                url: '/candidate-delete',
                success: function(msg) {
                    dateTableCandidate.ajax.reload();
                    if (msg.result === true) {
                        $('body').notification({
                            type: 'info',
                            title: 'Löschen erfolgreich',
                            message: 'Der Datensatz wurde erfolgreich gelöscht.',
                            autoClose: 4000
                        });
                    } else {
                        $('body').notification({
                            type: 'error',
                            title: 'Fehler',
                            message: 'Der Datensatz konnte leider nicht gelöscht werden.',
                            // autoClose: 4000
                        });
                    }
                }
            });
        })
    }
});
